(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const viewer = $('[data-pw6-story-viewer]');
  const state = { cards: [], index: 0, timer: 0, slideTimer: 0, startedAt: 0, duration: 6000, trigger: null, payload: null };

  const safeJson = node => {
    try { return JSON.parse(node?.textContent || '{}'); } catch { return {}; }
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const clearTimers = () => {
    window.clearInterval(state.timer);
    window.clearInterval(state.slideTimer);
    state.timer = 0;
    state.slideTimer = 0;
  };
  const toast = message => {
    const node = $('[data-pw3-toast]');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    window.clearTimeout(node._pw6Timer);
    node._pw6Timer = window.setTimeout(() => node.classList.remove('is-visible'), 2300);
  };

  const initButtons = root => {
    const selectors = [
      '[data-pw6-button]', '.pw3-button', '.pw3-card__quick button', '.pw4-pdp__add',
      '.pw4-cart__checkout', '.pw5-ritual-teaser__actions button', '.pw5-value__product form button'
    ].join(',');
    $$(selectors, root).forEach(button => {
      if (button.dataset.pw6ButtonReady === 'true') return;
      button.dataset.pw6ButtonReady = 'true';
      button.classList.add('pw6-interactive-button');
      button.addEventListener('pointermove', event => {
        const rect = button.getBoundingClientRect();
        button.style.setProperty('--pw6-x', `${event.clientX - rect.left}px`);
        button.style.setProperty('--pw6-y', `${event.clientY - rect.top}px`);
      });
      button.addEventListener('click', event => {
        if (button.disabled || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const rect = button.getBoundingClientRect();
        const ripple = document.createElement('i');
        ripple.className = 'pw6-ripple';
        ripple.style.left = `${event.clientX - rect.left}px`;
        ripple.style.top = `${event.clientY - rect.top}px`;
        button.append(ripple);
        window.setTimeout(() => ripple.remove(), 720);
      });
    });
  };

  const animateCount = node => {
    if (!node || node.dataset.pw6CountReady === 'true') return;
    node.dataset.pw6CountReady = 'true';
    const target = Math.max(0, Number(node.dataset.pw6Count || 0));
    if (!target) { node.textContent = '0'; return; }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { node.textContent = target.toLocaleString('tr-TR'); return; }
    const duration = Math.min(1000, 360 + target * 9);
    const started = performance.now();
    const frame = now => {
      const ratio = Math.min(1, (now - started) / duration);
      const eased = 1 - Math.pow(1 - ratio, 3);
      node.textContent = Math.round(target * eased).toLocaleString('tr-TR');
      if (ratio < 1) requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
  };

  const initCounters = root => {
    const nodes = $$('[data-pw6-count]', root);
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) { nodes.forEach(animateCount); return; }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      animateCount(entry.target);
      observer.unobserve(entry.target);
    }), { threshold: .45 });
    nodes.forEach(node => observer.observe(node));
  };

  const initSlideshows = root => {
    $$('[data-pw6-story-slideshow]', root).forEach(slideshow => {
      if (slideshow.dataset.pw6Ready === 'true') return;
      slideshow.dataset.pw6Ready = 'true';
      const slides = $$('.pw6-story-slide', slideshow);
      if (slides.length < 2) return;
      let index = 0;
      let timer = 0;
      const show = next => {
        index = next % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      };
      const play = () => {
        if (timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(() => show(index + 1), 2500);
      };
      const pause = () => { window.clearInterval(timer); timer = null; };
      show(0);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => entries.forEach(entry => entry.isIntersecting ? play() : pause()), { threshold: .35 }).observe(slideshow);
      } else play();
    });
    $$('[data-pw6-story-collection] video', root).forEach(video => {
      if (video.dataset.pw6Observed === 'true') return;
      video.dataset.pw6Observed = 'true';
      video.muted = true;
      video.playsInline = true;
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) video.play().catch(() => {}); else video.pause();
      }), { threshold: .55 }).observe(video);
    });
  };

  const cardPayload = card => safeJson($('[data-pw6-story-payload]', card));
  const mediaFromCard = card => {
    const video = $('video', card);
    const source = $('video source', card);
    const videoSrc = source?.src || video?.currentSrc || video?.src || '';
    const images = [...new Set($$('img', card).map(image => image.currentSrc || image.src).filter(Boolean))];
    if (videoSrc) return [{ type: 'video', src: videoSrc, poster: video?.poster || images[0] || '' }];
    return images.map(src => ({ type: 'image', src }));
  };

  const buildProgress = () => {
    const host = $('[data-pw6-story-progress]', viewer);
    if (host) host.innerHTML = state.cards.map(() => '<i><b data-pw6-progress-bar></b></i>').join('');
  };
  const setProgress = ratio => {
    $$('[data-pw6-progress-bar]', viewer).forEach((bar, index) => {
      const value = index < state.index ? 1 : index > state.index ? 0 : Math.max(0, Math.min(1, ratio));
      bar.style.transform = `scaleX(${value})`;
    });
  };

  const renderSignals = payload => {
    const host = $('[data-pw6-story-signals]', viewer);
    if (!host) return;
    const items = [];
    if (Number(payload.rating) > 0 && Number(payload.reviewCount) > 0) items.push(`<span class="pw6-story-viewer__signal pw6-story-viewer__signal--rating"><b>★★★★★</b>${payload.rating} • ${payload.reviewCount} gerçek yorum</span>`);
    if (Number(payload.viewCount) >= 50) items.push(`<span class="pw6-story-viewer__signal" title="Shopify Analytics: son 90 gün"><i></i><b data-pw6-view-count>${Number(payload.viewCount).toLocaleString('tr-TR')}</b> ürün görüntülemesi</span>`);
    if (Number(payload.purchaseCount) > 0) items.push(`<span class="pw6-story-viewer__signal"><i></i><b>${Number(payload.purchaseCount).toLocaleString('tr-TR')}</b> gerçek satın alım</span>`);
    if (payload.inStock) items.push('<span class="pw6-story-viewer__signal"><i></i>STOKTA • GÖNDERİME HAZIR</span>');
    host.innerHTML = items.join('');
    host.hidden = items.length === 0;
  };

  const renderReviews = payload => {
    const host = $('[data-pw6-review-list]', viewer);
    const summary = $('[data-pw6-review-summary]', viewer);
    if (!host) return;
    const reviews = Array.isArray(payload.reviews) ? payload.reviews : [];
    if (summary) summary.textContent = Number(payload.reviewCount) > 0 ? `${payload.rating} / 5 • ${payload.reviewCount} gerçek yorum` : 'Henüz yorum bulunmuyor';
    if (!reviews.length) {
      host.innerHTML = '<div class="pw6-story-viewer__review-empty">Bu üründe henüz yayınlanmış müşteri yorumu yok. Yorum geldiğinde bu alan otomatik olarak dolacak.</div>';
      return;
    }
    host.innerHTML = reviews.map(review => {
      const imageUrl = escapeHtml(review.image || '');
      const author = escapeHtml(review.author || 'Pielurd müşterisi');
      const body = escapeHtml(review.body || '');
      const initial = escapeHtml(String(review.initial || review.author || 'P').slice(0, 1));
      const visual = imageUrl
        ? `<img src="${imageUrl}" alt="${author}"><small>${review.hasCustomerImage ? 'MÜŞTERİ GÖRSELİ' : 'ÜRÜN GÖRSELİ'}</small><b>${initial}</b>`
        : `<span>${initial}</span>`;
      const stars = '★★★★★'.slice(0, Math.max(1, Math.min(5, Number(review.rating) || 5)));
      return `<article class="pw6-review-card"><div class="pw6-review-card__visual">${visual}</div><div class="pw6-review-card__body"><div class="pw6-review-card__meta"><strong>${author}</strong><span>${stars}</span></div><p>“${body}”</p><small>${review.verified ? 'DOĞRULANMIŞ ALICI' : 'MAĞAZA ZİYARETÇİSİ YORUMU'}</small></div></article>`;
    }).join('');
  };

  const hydrateCommerce = payload => {
    const panel = $('[data-pw6-story-commerce]', viewer);
    if (!panel) return;
    const image = $('[data-pw6-story-product-image]', panel);
    const title = $('[data-pw6-story-title]', panel);
    const caption = $('[data-pw6-story-caption]', panel);
    const benefit = $('[data-pw6-story-benefit]', panel);
    const price = $('[data-pw6-story-price]', panel);
    const buttonPrice = $('[data-pw6-story-button-price]', panel);
    const variant = $('[data-pw6-story-variant]', panel);
    const button = $('button[type="submit"]', panel);
    if (image) { image.src = payload.productImage || ''; image.alt = payload.title || ''; }
    if (title) title.textContent = payload.title || '';
    if (caption) caption.textContent = payload.caption || 'VİDEODAKİ ÜRÜN';
    if (benefit) benefit.textContent = payload.benefit || '';
    if (price) price.textContent = payload.price || '';
    if (buttonPrice) buttonPrice.textContent = payload.price || '';
    if (variant) variant.value = payload.variant || '';
    $$('[data-pw6-story-link]', panel).forEach(link => { link.href = payload.url || '#'; link.hidden = !payload.url; });
    if (button) {
      button.disabled = !payload.variant || payload.available === false;
      const label = $('span', button);
      if (label) label.textContent = payload.available === false ? 'TÜKENDİ' : 'SEPETE EKLE';
    }
    const reviewButton = $('[data-pw6-open-review-sheet]', panel);
    if (reviewButton) {
      reviewButton.hidden = Number(payload.reviewCount) < 1;
      const count = $('[data-pw6-review-button-count]', reviewButton);
      if (count) count.textContent = Number(payload.reviewCount) > 0 ? `(${payload.reviewCount})` : '';
    }
    renderSignals(payload);
    renderReviews(payload);
    panel.hidden = !payload.title;
  };

  const renderMedia = (card, payload) => {
    const host = $('[data-pw6-story-media]', viewer);
    if (!host) return;
    host.replaceChildren();
    const media = mediaFromCard(card);
    if (!media.length && payload.productImage) media.push({ type: 'image', src: payload.productImage });
    if (!media.length) return;
    if (media[0].type === 'video') {
      const video = document.createElement('video');
      video.src = media[0].src;
      if (media[0].poster) video.poster = media[0].poster;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = false;
      video.preload = 'auto';
      video.muted = false;
      host.append(video);
      state.duration = 10000;
      video.addEventListener('loadedmetadata', () => {
        if (Number.isFinite(video.duration) && video.duration > 0) state.duration = Math.max(3800, video.duration * 1000);
        state.startedAt = performance.now();
      }, { once: true });
      video.addEventListener('ended', () => nextStory(1));
      video.play().catch(() => { video.muted = true; video.play().catch(() => {}); });
      return;
    }
    let index = 0;
    const showImage = () => {
      const image = document.createElement('img');
      image.src = media[index].src;
      image.alt = payload.title || '';
      image.decoding = 'async';
      host.replaceChildren(image);
    };
    showImage();
    state.duration = Math.max(5400, media.length * 1750);
    if (media.length > 1) state.slideTimer = window.setInterval(() => { index = (index + 1) % media.length; showImage(); }, state.duration / media.length);
  };

  const closeReviewSheet = () => $('[data-pw6-review-sheet]', viewer)?.classList.remove('is-open');
  const render = () => {
    if (!viewer || !state.cards.length) return;
    clearTimers();
    closeReviewSheet();
    state.index = (state.index + state.cards.length) % state.cards.length;
    const card = state.cards[state.index];
    const payload = cardPayload(card);
    state.payload = payload;
    const count = $('[data-pw6-story-count]', viewer);
    if (count) count.textContent = `${state.index + 1} / ${state.cards.length}`;
    setProgress(0);
    hydrateCommerce(payload);
    renderMedia(card, payload);
    state.startedAt = performance.now();
    state.timer = window.setInterval(() => {
      const ratio = Math.min(1, (performance.now() - state.startedAt) / state.duration);
      setProgress(ratio);
      if (ratio >= 1) nextStory(1);
    }, 70);
  };

  function nextStory(direction) {
    if (!viewer?.open || !state.cards.length) return;
    const next = state.index + direction;
    if (next >= state.cards.length) { closeViewer(); return; }
    state.index = next < 0 ? state.cards.length - 1 : next;
    render();
  }

  const openViewer = trigger => {
    if (!viewer) return;
    const collection = trigger.closest('[data-pw6-story-collection]');
    if (!collection) return;
    state.cards = $$('[data-pw6-story-card]', collection);
    const card = trigger.closest('[data-pw6-story-card]');
    state.index = Math.max(0, state.cards.indexOf(card));
    state.trigger = trigger;
    buildProgress();
    if (!viewer.open) viewer.showModal();
    document.body.classList.add('is-locked');
    render();
    if (trigger.matches('[data-pw6-open-reviews]') || trigger.closest('[data-pw6-open-reviews]')) window.setTimeout(() => { clearTimers(); $('[data-pw6-review-sheet]', viewer)?.classList.add('is-open'); }, 80);
  };

  function closeViewer() {
    clearTimers();
    closeReviewSheet();
    $('[data-pw6-story-media]', viewer)?.replaceChildren();
    if (viewer?.open) viewer.close();
    document.body.classList.remove('is-locked');
    state.trigger?.focus?.({ preventScroll: true });
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-pw6-story-open]');
    if (trigger && !event.target.closest('form')) { event.preventDefault(); openViewer(trigger); }
  });
  $('[data-pw6-story-close]', viewer)?.addEventListener('click', closeViewer);
  $('[data-pw6-story-prev]', viewer)?.addEventListener('click', () => nextStory(-1));
  $('[data-pw6-story-next]', viewer)?.addEventListener('click', () => nextStory(1));
  $('[data-pw6-open-review-sheet]', viewer)?.addEventListener('click', () => { clearTimers(); $('[data-pw6-review-sheet]', viewer)?.classList.add('is-open'); });
  $('[data-pw6-close-review-sheet]', viewer)?.addEventListener('click', () => { closeReviewSheet(); render(); });
  viewer?.addEventListener('click', event => { if (event.target === viewer) closeViewer(); });
  viewer?.addEventListener('cancel', event => { event.preventDefault(); closeViewer(); });
  viewer?.addEventListener('submit', event => { if (event.target.matches('[data-pw6-story-form]')) window.setTimeout(closeViewer, 520); });
  document.addEventListener('keydown', event => {
    if (!viewer?.open) return;
    if (event.key === 'ArrowLeft') nextStory(-1);
    if (event.key === 'ArrowRight') nextStory(1);
  });
  let startX = null;
  let startY = null;
  viewer?.addEventListener('pointerdown', event => {
    if (event.target.closest('a,button,form,[data-pw6-review-sheet]')) return;
    startX = event.clientX; startY = event.clientY;
  });
  viewer?.addEventListener('pointerup', event => {
    if (startX === null) return;
    const dx = event.clientX - startX; const dy = event.clientY - startY;
    startX = startY = null;
    if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) nextStory(dx < 0 ? 1 : -1);
  });

  const init = root => { initButtons(root); initCounters(root); initSlideshows(root); };
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
